/**
 * Impersonate user - Row action injected into users entity via injectActions.
 * Route: POST /users/impersonate/:id
 */

import type { ActionDefinition } from '@gzl10/nexus-sdk'
import type { MiddlewareHandler } from 'hono'
import type { AuthService } from '../auth.service.js'
import { getRequestInfo } from './helpers.js'

export const impersonateAction: ActionDefinition = {
  key: 'impersonate',
  label: { en: 'Impersonate', es: 'Suplantar' },
  icon: 'mdi:account-switch',
  scope: 'row',
  method: 'POST',
  select: ['id'],
  confirm: {
    type: 'simple',
    message: { en: 'You will impersonate this user. Your admin session will be preserved.', es: 'Suplantarás a este usuario. Tu sesión de admin se preservará.' },
    severity: 'warning'
  },
  casl: { action: 'manage' },
  middleware: (ctx) => (ctx.services.get('authRateLimits') as { admin: MiddlewareHandler }).admin,
  handler: async (ctx, input, c) => {
    const { _record, _authUserId } = input as { _record: { id: string }; _authUserId?: string }
    if (!_authUserId) throw new ctx.core.errors.UnauthorizedError('Usuario no autenticado')
    const authService = ctx.services.get<AuthService>('auth')
    return authService.impersonate(_authUserId, _record.id, getRequestInfo(c))
  }
}
